(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('salesBook', {
                parent: 'app',
                url: '/salesBook',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/salesBook/salesBook.html',
                        controller: 'salesBookController',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['salesBook']);
                            }],
                            taxpayers:['taxpayerService',function(taxpayerService){
                                return taxpayerService.getTaxpayers(true);
                            }]
                        }
                    }
                }
            });
    }
})();
